import TotalIndicator from './TotalIndicator.component';

export default TotalIndicator;
